import { ref, onMounted } from 'vue';

/**
 * @typedef {Object} UseOncePerSessionReturn
 * @property {import('vue').Ref<boolean>} hasBeenUsed
 */

/**
 * Use this composable to store a value in the session storage and make sure it is only used once per session.
 *
 * @param {string} key
 * @param {number} expirationMinutes
 * @returns {UseOncePerSessionReturn}
 */
export const useOncePerSession = (key, expirationMinutes = 30) => {
  /* istanbul ignore file */
  const hasBeenUsed = ref(false);

  onMounted(() => {
    const storageKey = `useOncePerSession:${key}`;
    const storageValue = Number(sessionStorage.getItem(storageKey));
    const now = Date.now();
    const expirationTime = now + expirationMinutes * 60 * 1000;

    if (storageValue > now) {
      hasBeenUsed.value = true;
    } else {
      sessionStorage.setItem(storageKey, expirationTime.toString());
    }
  });

  return {
    hasBeenUsed,
  };
};

export default useOncePerSession;
